import { useTranslation } from "react-i18next";
import { Locale } from "@/i18n";

export const useLocale = (): Locale => {
  const { i18n } = useTranslation();

  return i18n.language as Locale;
};
